/* Core & libraries */
import React, { useState } from 'react';
import classnames from "classnames";
import { FormattedMessage } from "react-intl";
import { Card } from "react-bootstrap";
import { useTheme } from "react-jss";
import classNames from "classnames";

/* Helpers, constants, custom methods, internal libraries */
import { useCreditRequestHistoryList } from '../../../hooks/useCreditRequestHistoryList';
import { useRetroService } from '../../../services/retroService';

/* Components */
import CreditRequestHistoryFilters , { CREDIT_REQUEST_HISTORY_GRID_TYPE } from "./creditRequestHistoryFilters";
import CreditRequestHistoryNoData from "./creditRequestHistoryNoData";
import UCGrid from "components/ucgrid";
import UCButton from "components/buttons";
import { ReactComponent as DownloadIcon } from "resources/images/download-02.svg";

/* Styles */
import styles from "./styles";

const CreditRequestHistory = (props) => {
  const theme = useTheme();
  const classes = styles({theme});
  const [gridOptions, setGridOptions] = useState({
    page: 1,
    status: CREDIT_REQUEST_HISTORY_GRID_TYPE.APPROVED
  })
  const {creditRequestHistoryList, getCreditRequestHistory} = useCreditRequestHistoryList(gridOptions);
  const {downloadReport} = useRetroService();
  const handlePageChange = async (page) => {
    const newGridOptions = { ...gridOptions, page };
    await getCreditRequestHistory(newGridOptions);
    setGridOptions(newGridOptions);
  }

  return (
    <div className={classnames('retro-history', classes.retroHistory)}>
      <Card className={classnames('retro-history-card', classes.retroHistoryCard)}>
        <Card.Header className={classes.retroHistoryHeader}>
          <div className={classes.retroHistoryHeaderTitleContainer}>
            <Card.Title>
              <FormattedMessage id="retro.grid.title" />
            </Card.Title>
            <Card.Text>
              <FormattedMessage id="retro.grid.subtitle" />
            </Card.Text>
          </div>

          <div className={classes.retroHistoryHeaderButtonContainer}>
            <UCButton
              type="default"
              className={classes.button}
              onClick={() => downloadReport(gridOptions)}
              text={<FormattedMessage id="retro.buttonDownload" />}
              icon={<DownloadIcon className={classes.retroHistoryDownloadSVG} />}
              disabledIconClassName={classes.retroHistoryDownloadSVGDisabled}
              loadingStateStyling={classes.downloadLoadingState}
              spinnerClassName={classes.spinnerStyle}
              disabled={creditRequestHistoryList?.results?.dataItems?.length === 0}
              spinner={{
                name: 'creditRequestDownloadSpinner',
                size: 20,
              }}
            />
          </div>
        </Card.Header>

        <Card.Header className={classes.retroHistoryCardHeaderSmall}>
          <CreditRequestHistoryFilters
            gridOptions={gridOptions}
            setGridOptions={setGridOptions}
          />
        </Card.Header>
        <Card.Body className={classes.retroHistoryCardBody}>
          <UCGrid
            gridName="retro"
            spinner="creditRequestGridSpinner"
            data={creditRequestHistoryList?.results}
            columns={creditRequestHistoryList?.columns}
            actions={creditRequestHistoryList?.actions}
            noDataComponent={
              <CreditRequestHistoryNoData
                gridOptions={gridOptions}
                setGridOptions={setGridOptions}
              />
            }
            handlePageChange={handlePageChange}
            defaultSort={creditRequestHistoryList?.defaultSort}
            gridMobileWrapperClassName={classNames(classes.gridMobileWrapperClassName)}
            gridWrapperClassName={classes.gridWrapperClassName}
            actionsDots={false}
            onRowClick={() => {}}
            handleSort={(column, sortDirection) =>
              setGridOptions({
                ...gridOptions,
                sortby: column.id,
                sortdirection: sortDirection === 'desc' ? 'dsc' : sortDirection,
              })
            }
            customColumns={{
              recordLocator: (row) => (
                <div className={"bold"}>{row.recordLocator}</div>
              ),
              travelerName: (row) => (
                <div className={"travelerName"}>{row.travelerName}</div>
              ),
              description: (row) => (
                <div>{ row?.description ? <FormattedMessage id={row?.description} /> : "" }</div>
              ),
            }}
            columnCustomWidth={{
              description: "350px",
            }}
          />
        </Card.Body>
      </Card>
    </div>
  );
}

export default CreditRequestHistory;